import { ContentContainer, PageLayout, PageTitle } from "components/layout"
import ReportTabs from "./components/report-tabs"

const ReportGenerator = () => {
    return (
        <PageLayout>
            <PageTitle title="Geração de Excel" description="Visualize os dados de conciliação de forma controlada." />
            <ContentContainer>
                <ReportTabs />
            </ContentContainer>
        </PageLayout>
    )
}

export default ReportGenerator
